<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-03 17:10:00
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-30 17:43:36
-->
<template>
	<div style="display: inline-block">
		<span>{{ roleListName }}</span>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	name: 'LabelCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		roleListName() {
			if (this.row.role && this.row.role.length) {
				return this.row.role.map(item => item.name).join('、');
			} else {
				return '-';
			}
		},
	},
	props: {},
	components: {},

	mounted() {},

	methods: {},
};
</script>
